import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import { DatePickerComponent } from "Component/Custom";
import InputValues from "Component/FloatValues";
import get from "lodash/get";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import React from "react";
import { connect } from "react-redux";
import { convertDateForBackend, months } from "Utils";
import { getdateonly, getmonthonly, mergedatemonth } from "Utils/dates";
import { instance } from "../../../../../../Actions/AxiosInstance";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { radioinputconverter } from "../../../../../../Component/DynamicForm/Fields/Radio";
import { ErrorMessages } from "../../../../../../Constants";
import moment from "moment";

const POST_DATA = {
  declarationconfigid: null, // null,
  declarationstartmonthid: null, // 6,
  declarationendmonthid: null, // 7,
  declarationstartday: null, // 1,
  declarationendday: null, // 30,
  newempdeclarationday: null, // 30,
  isdeclarationapproval: false, // false,
  isallowmiddle: false, // true,
  middlestartmonthid: null, // 8,
  middleendmonthid: null, // 8,
  middlestartday: null, // 1,
  middleendday: null, // 30,
  ismiddleapproval: null, // false,
  issubmissionrequire: null, // true,
  isinvestmentcompulsory: null, // false,
  submissionstartmonthid: null, // 9,
  submissionendmonthid: null, // 9,
  submissionstartday: null, // 1,
  submissionendday: null, // 30,
  submissionfstartmonthid: null, // 1,
  submissionfendmonthid: null, // 2,
  submissionfstartday: null, // 1,
  submissionfendday: null, // 20,
  issubmissionnapproval: null, // false,
  effectivefrom: null, // "2019-09-09",
};
export class ITDeclaration extends React.Component {
  state = {
    postdata: POST_DATA,
    empList: [],
    cycles: [],
    SelectedEmpData: [],
    loading: true,
  };

  componentDidMount() {
    this.getdata();
  }

  getInit = () => {
    instance
      .get(`payroll/getpayrollcycle`)
      .then((resp) => {
        // const curentcycle = resp.data.result.find((x) => x.year == moment(new Date()).format("YYYY"));
        const curentcycle = resp.data.result.find((x) => x.payrollcycletypeid == 2);
        // instance
        // .get(`payroll/getsalarycycle/${get(curentcycle, "payrollcycledurationid", "")}`)
        // .then((result) => {
        const sameyears = months.filter((month) => month.displayvalue >= moment(curentcycle.payrollcyclestartdate, "YYYY-MM-DD").format("MM")).map((m) => ({
          payrollmonthid: m.displayvalue,
          payrollyear: moment(new Date(curentcycle.year)).format("YYYY"),
        }));
        console.log('sameyears: ', sameyears);
        const nextyears = months.filter((month) => month.displayvalue < moment(curentcycle.payrollcyclestartdate, "YYYY-MM-DD").format("MM")).map((m) => ({
          payrollmonthid: m.displayvalue,
          payrollyear: `${parseInt(moment(new Date(curentcycle.year)).format("YYYY")) + 1}`,
        }));
        console.log('nextyears: ', nextyears);
        this.setState({
          cycles: [...sameyears, ...nextyears],
          payrollcycle: curentcycle,
          loading: false,

          postdata: {
            ...this.state.postdata,
            declarationstartmonthid: getmonthonly(
              get(curentcycle, "payrollcyclestartdate", ""),
            ),
            declarationstartday: getdateonly(
              get(curentcycle, "payrollcyclestartdate", ""),
            ),
          },
        });
        // .catch((error) => {
        //   this.props.enqueueSnackbar(
        //     error.response ? error.response.data.error.message : error.message,
        //     { variant: "error" },
        //   );
        // });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  getdata = () => {
    instance
      .get("payroll/getdeclarationconfigbysubid")
      .then((resp) => {
        this.setState(
          {
            postdata: get(resp, "data.result[0]", POST_DATA),
          },
          this.getInit,
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  submit = () => {
    const { postdata } = this.state;
    console.log("postdata: ", postdata);
    const {
      declarationstartmonthid,
      declarationendmonthid,
      newempdeclarationday,
      isallowmiddle,
      middlestartmonthid,
      middleendmonthid,
    } = postdata;

    if (
      declarationstartmonthid
      && declarationendmonthid
      && newempdeclarationday
      && isallowmiddle ? middlestartmonthid && middleendmonthid : true
    ) {
    instance
      .post("payroll/createdeclarationconfig", postdata)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        this.props.getpayrollconfig();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    } else {
      this.props.enqueueSnackbar(
        ErrorMessages.E0020,
        { variant: "error" },
      );
    }
  };

  showLoader() {
    return <div className="pre-loader" style={{
      marginLeft: "50%",
      transform: "translateX(-50%)"
    }} >Loading...</div>;
  }


  updatepostdata = (key, value) => {
    console.log("key, value: ", key, value);
    this.setState({
      postdata: {
        ...this.state.postdata,
        [key]: value,
      },
    });
  };

  render() {
    const { postdata, payrollcycle, cycles = [] } = this.state;
    console.log('postdata: ', postdata);
    return (
      <div>
        <Helmet>
          <title>{headersList.Config.Misc.ITDeclaration.header}</title>
        </Helmet>
        <Grid container>
        {this.state.loading == true ? (
                    this.showLoader()
                  ) : <>
          {payrollcycle
          && <Grid md={12} xs={12} lg={12} sm={12}>
            <div>
              <div
                className="margin-bottom-32 padding16 width50"
                style={{ background: "#f7f8f8" }}
              >
                <div className="small-dark-secondary margin-bottom-8">
                  What is the first IT Declaration window?
                </div>
                <div className="t-13 t-bold text-color-black">
                  For existing employees
                </div>

                <div className="margin-top-16">
                  <span className="floatleft">
                    <DatePickerComponent
                      className="width70"
                      // start="Month"
                      // depth="Month"
                      allowEdit={false}
                      disabled={true}
                      customFormat="dd MMM"
                      value={
                        payrollcycle
                        && new Date(payrollcycle.payrollcyclestartdate)
                      }
                      min={
                        payrollcycle
                        && new Date(payrollcycle.payrollcyclestartdate)
                      }
                      max={
                        postdata.declarationendmonthid
                        ? cycles[0] && cycles[0].payrollmonthid > postdata.declarationendmonthid
                        ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.declarationendmonthid}-${postdata.declarationendday}`)
                        : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.declarationendmonthid}-${postdata.declarationendday}`)
                        : postdata.submissionstartmonthid
                        ? cycles[0] && cycles[0].payrollmonthid > postdata.submissionstartmonthid
                        ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.submissionstartmonthid}-${postdata.submissionstartday}`)
                        : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.submissionstartmonthid}-${postdata.submissionstartday}`)
                        : payrollcycle
                        && new Date(payrollcycle.payrollcycleenddate)
                      }
                      change={(e) => {
                        this.setState({
                          postdata: {
                            ...postdata,
                            declarationstartday: getdateonly(
                              convertDateForBackend(e.value),
                            ),
                            declarationstartmonthid: getmonthonly(
                              convertDateForBackend(e.value),
                            ),
                          },
                        });
                      }}
                      hideClearIcon
                    />
                  </span>
                  <span
                    className="floatleft margin-top-8"
                    style={{ marginRight: 50 }}
                  >
                    {" "}
                    to{" "}
                  </span>
                  <span className="floatleft">
                    <DatePickerComponent
                      className="width70"
                      start="Month"
                      depth="Month"
                      customFormat="dd MMM"
                      disabled={(this.props.permissions && !this.props.permissions.editable) || !postdata.declarationstartmonthid

                        // cycles[0] && cycles[0].payrollmonthid > postdata.declarationstartmonthid ?
                        // `${parseInt(cycles[0].payrollyear) + 1}-${postdata.declarationstartmonthid}-${postdata.declarationstartday}`
                        // : `${parseInt(cycles[0].payrollyear) + 1}-${postdata.declarationstartmonthid}-${postdata.declarationstartday}`
                      }
                      //   !mergedatemonth({
                      //     date: postdata.declarationstartday,
                      //     month: postdata.declarationstartmonthid,
                      //   })
                      // }
                      min={
                        // payrollcycle
                        // && new Date(
                        //   mergedatemonth({
                        //     date: postdata.declarationstartday,
                        //     month: postdata.declarationstartmonthid,
                        //   }),
                        // )
                        postdata.declarationstartmonthid
                        ? cycles[0] && cycles[0].payrollmonthid > postdata.declarationstartmonthid
                        ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.declarationstartmonthid}-${postdata.declarationstartday}`)
                        : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.declarationstartmonthid}-${postdata.declarationstartday}`)
                        : payrollcycle
                        && new Date(payrollcycle.payrollcyclestartdate)
                      }
                      max={
                        postdata.isallowmiddle
                        ? cycles[0] && cycles[0].payrollmonthid > postdata.middlestartmonthid
                        ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.middlestartmonthid}-${postdata.middlestartday}`)
                        : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.middlestartmonthid}-${postdata.middlestartday}`)
                        : postdata.submissionstartmonthid
                        ? cycles[0] && cycles[0].payrollmonthid > postdata.submissionstartmonthid
                        ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.submissionstartmonthid}-${postdata.submissionstartday}`)
                        : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.submissionstartmonthid}-${postdata.submissionstartday}`)
                        : payrollcycle
                        && new Date(payrollcycle.payrollcycleenddate)
                      }
                      // value={mergedatemonth({
                      //   date: postdata.declarationendday,
                      //   month: postdata.declarationendmonthid,
                      // })}
                      value={postdata.declarationendmonthid
                        ? cycles[0] && cycles[0].payrollmonthid > postdata.declarationendmonthid
                        ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.declarationendmonthid}-${postdata.declarationendday}`)
                        : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.declarationendmonthid}-${postdata.declarationendday}`)
                        : null}
                        change={(e) => {
                        this.setState({
                          postdata: {
                            ...postdata,
                            declarationendday: getdateonly(
                              convertDateForBackend(e.value),
                            ),
                            declarationendmonthid: getmonthonly(
                              convertDateForBackend(e.value),
                            ),
                          },
                        });
                      }}
                      hideClearIcon
                    />
                  </span>
                </div>

                <br />

                <div className="t-13 t-bold text-color-black margin-top-32">
                  For new employees
                </div>

                <div>
                  <span>Until</span>
                  <span>
                    <InputValues
                      min="1"
                      max="60"
                      field="newempdeclarationday"
                      defaultvalue={1}
                      onChange={(e) =>
                        this.setState({
                          postdata: {
                            ...postdata,
                            newempdeclarationday: e.target.value
                              ? parseInt(e.target.value)
                              : null,
                          },
                        })
                      }
                      disabled={this.props.permissions && !this.props.permissions.editable}
                      value={postdata.newempdeclarationday}
                    />
                  </span>
                  <span>days after date of joining</span>
                </div>

                <div className="margin-bottom-10">
                  <Switch
                    checked={postdata.isdeclarationapproval ? true : false}
                    onChange={(val) =>
                      this.setState({
                        postdata: {
                          ...postdata,
                          isdeclarationapproval: val.target.checked,
                        },
                      })
                    }
                    disabled={this.props.permissions && !this.props.permissions.editable}
                    value={postdata.isdeclarationapproval ? true : false}
                    color="primary"
                  />
                  <span>Require approval for declaration to be effective</span>
                </div>
              </div>

              {postdata.isdeclarationapproval == false && (
                <div className="margin-bottom-32 bg-light-red padding8 width50">
                  ⚠️ All values declared by the employee will be considered for
                  calculation of taxes. If unchecked, this can lead to increased
                  taxable income for the employees during the end of financial
                  year.
                </div>
              )}

              <div
                className="margin-bottom-32 padding16 width50"
                style={{ background: "#f7f8f8", minHeight: 54 }}
              >
                <div className="small-dark-secondary margin-bottom-8">
                  Allow employees to set declared value in the middle of the
                  financial year?
                </div>

                <span className="floatleft width50">
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: postdata.isallowmiddle == true,
                      label: "Yes",
                      disabled: this.props.permissions && !this.props.permissions.editable,
                    })}
                    onChange={() => this.updatepostdata("isallowmiddle", true)}
                  />
                </span>
                <span className="floatleft width50">
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: postdata.isallowmiddle == false,
                      label: "No",
                      disabled: this.props.permissions && !this.props.permissions.editable,
                    })}
                    onChange={() =>
                      this.setState({
                        postdata: {
                          ...postdata,
                          isallowmiddle: false,
                          middlestartmonthid: null,
                          middlestartday: null,
                          middleendmonthid: null,
                          middleendday: null,
                          ismiddleapproval: null,
                        },
                      })
                    }
                    // change={(e) => {
                    //   this.setState({
                    //     postdata: {
                    //       ...postdata,
                    //       isallowmiddle: false,
                    //       middlestartmonthid: null,
                    //       middlestartday: null,
                    //       middleendmonthid: null,
                    //       middleendday: null,
                    //       ismiddleapproval: null,
                    //     },
                    //   });
                    // }}
                  />
                </span>

                {postdata.isallowmiddle && (
                  <div>
                    <div className="t-13 t-bold text-color-black">
                      Kindly select the effective declaration window
                    </div>

                    <div className="margin-top-16">
                      <span className="floatleft">
                        <DatePickerComponent
                          className="width90"
                          start="Month"
                          depth="Month"
                          customFormat="dd MMM"
                          disabled={
                            (this.props.permissions && !this.props.permissions.editable) || !postdata.declarationendmonthid
                            // !mergedatemonth({
                            //   date: postdata.declarationendday,
                            //   month: postdata.declarationendmonthid,
                            // })
                          }
                          min={
                            postdata.declarationendmonthid
                            ? cycles[0] && cycles[0].payrollmonthid > postdata.declarationendmonthid
                            ? `${parseInt(cycles[0].payrollyear) + 1}-${postdata.declarationendmonthid}-${postdata.declarationendday}`
                            : cycles[0] && `${parseInt(cycles[0].payrollyear)}-${postdata.declarationendmonthid}-${postdata.declarationendday}`
                            : payrollcycle
                            && new Date(payrollcycle.payrollcyclestartdate)
                            // payrollcycle
                            // && mergedatemonth({
                            //   date: postdata.declarationendday,
                            //   month: postdata.declarationendmonthid,
                            // })
                          }
                          max={
                            postdata.middleendmonthid
                            ? cycles[0] && cycles[0].payrollmonthid > postdata.middleendmonthid
                            ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.middleendmonthid}-${postdata.middleendday}`)
                            : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.middleendmonthid}-${postdata.middleendday}`)
                            : postdata.submissionstartmonthid
                            ? cycles[0] && cycles[0].payrollmonthid > postdata.submissionstartmonthid
                            ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.submissionstartmonthid}-${postdata.submissionstartday}`)
                            : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.submissionstartmonthid}-${postdata.submissionstartday}`)
                            : payrollcycle
                            && new Date(payrollcycle.payrollcycleenddate)
                          }
                          // value={postdata.middlestartmonthid ? mergedatemonth({
                          //   date: postdata.middlestartday,
                          //   month: postdata.middlestartmonthid,
                          // }) : null}
                          value={postdata.middlestartmonthid
                            ? cycles[0] && cycles[0].payrollmonthid > postdata.middlestartmonthid
                            ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.middlestartmonthid}-${postdata.middlestartday}`)
                            : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.middlestartmonthid}-${postdata.middlestartday}`)
                            : null}
                          change={(e) => {
                            this.setState({
                              postdata: {
                                ...postdata,
                                middlestartday: getdateonly(
                                  convertDateForBackend(e.value),
                                ),
                                middlestartmonthid: getmonthonly(
                                  convertDateForBackend(e.value),
                                ),
                              },
                            });
                          }}
                          hideClearIcon
                        />
                      </span>
                      <span
                        className="floatleft margin-top-8"
                        style={{ marginRight: 19 }}
                      >
                        {" "}
                        to{" "}
                      </span>
                      <span className="floatleft">
                        <DatePickerComponent
                          className="width90"
                          start="Month"
                          depth="Month"
                          customFormat="dd MMM"
                          disabled={
                            (this.props.permissions && !this.props.permissions.editable) || !postdata.middlestartmonthid
                            // !mergedatemonth({
                            //   date: postdata.middlestartday,
                            //   month: postdata.middlestartmonthid,
                            // })
                          }
                          min={postdata.middlestartmonthid
                            ? cycles[0] && cycles[0].payrollmonthid > postdata.middlestartmonthid
                        ? `${parseInt(cycles[0].payrollyear) + 1}-${postdata.middlestartmonthid}-${postdata.middlestartday}`
                        : cycles[0] && `${parseInt(cycles[0].payrollyear)}-${postdata.middlestartmonthid}-${postdata.middlestartday}`
                        : null
                            // payrollcycle
                            // && mergedatemonth({
                            //   date: postdata.middlestartday,
                            //   month: postdata.middlestartmonthid,
                            // })
                            // payrollcycle
                            // && new Date(payrollcycle.payrollcyclestartdate)
                          }
                          max={
                            postdata.submissionstartmonthid
                            ? cycles[0] && cycles[0].payrollmonthid > postdata.submissionstartmonthid
                            ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.submissionstartmonthid}-${postdata.submissionstartday}`)
                            : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.submissionstartmonthid}-${postdata.submissionstartday}`)
                            : payrollcycle
                            && new Date(payrollcycle.payrollcycleenddate)
                          }
                          // value={postdata.middleendmonthid ? mergedatemonth({
                          //   date: postdata.middleendday,
                          //   month: postdata.middleendmonthid,
                          // }) : null}
                          value={postdata.middleendmonthid
                            ? cycles[0] && cycles[0].payrollmonthid > postdata.middleendmonthid
                            ? new Date(`${parseInt(cycles[0].payrollyear) + 1}-${postdata.middleendmonthid}-${postdata.middleendday}`)
                            : cycles[0] && new Date(`${parseInt(cycles[0].payrollyear)}-${postdata.middleendmonthid}-${postdata.middleendday}`)
                            : null}
                          change={(e) => {
                            this.setState({
                              postdata: {
                                ...postdata,
                                middleendday: getdateonly(
                                  convertDateForBackend(e.value),
                                ),
                                middleendmonthid: getmonthonly(
                                  convertDateForBackend(e.value),
                                ),
                              },
                            });
                          }}
                          hideClearIcon
                        />
                      </span>
                    </div>

                    <div className="margin-bottom-10 margin-top-64">
                      <Switch
                        checked={postdata.ismiddleapproval ? true : false}
                        onChange={(val) =>
                          this.setState({
                            postdata: {
                              ...postdata,
                              ismiddleapproval: val.target.checked,
                            },
                          })
                        }
                        disabled={this.props.permissions && !this.props.permissions.editable}
                        value={postdata.ismiddleapproval ? true : false}
                        color="primary"
                      />
                      <span>
                        Require approval for the declaration to be effective
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {this.props.permissions && this.props.permissions.editable &&
            <Grid container>
              <Grid
                item
                xs={12}
                md={6}
                sm={12}
                style={{ justifyContent: "flex-start", display: "flex" }}
              >
                <div>
                  <Button
                    className="btn btn-secondary-md-blue margin-right-8"
                    variant="contained"
                    onClick={this.submit}
                  >
                    Save
                  </Button>
                </div>
              </Grid>
            </Grid>
            }
          </Grid>
          }
          </>}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ITDeclaration);
